// import moment from 'moment'

export const storeQnA = {
    namespaced: true,
    state: {
        questions: [],
        qnaRoom: undefined,
        loading:false
    },
    getters: {
        GET_QnARoom(state) {
            return state.qnaRoom;
        },
        
        questions(state) {
            return state.questions.sort(function (a, b) { return new Date(b.question.timeStamp) - new Date(a.question.timeStamp) }) //b.question.ranking - a.question.ranking
                .sort(function (a, b) { return (a.question.isPublic === b.question.isPublic) ? 0 : a.question.isPublic ? -1 : 1; });

        },
        GET_NotPublicQuestions(state, getters) {            
            return getters.questions.filter(
                (s) => s.question.isPublic === false && s.question.isDiscard === false
            );
        },
        GET_NotPublicDiscardQuestions(state, getters) {
            return getters.questions.filter(
                (s) => s.question.isPublic === false && s.question.isDiscard === true
            );
        },
        GET_AnsweredQuestions(state, getters) {
            return getters.questions.filter(
                (s) => s.question.isAnswered === true
            );
        },
        GET_AnsweredUnQuestions(state, getters) {
            return getters.questions.filter(
                (s) => s.question.isAnswered == false
            );
        },
        GET_LiveQuestions(state, getters) {
            return getters.questions.filter(
                (s) => s.question.isPublic === true && s.question.isAnswered === false
            );
        },
        GET_loading(state)
        {
            return state.loading;
        }
    },
    mutations: {
        SET_QnARoom(state, payload) {
            state.qnaRoom = payload;
        },
        UPDATE_Questions(state, { questionInfo, remove }) {
            var idx = state.questions.findIndex(s => s.question.id === questionInfo.question.id)

            if (remove == true) {
                state.questions.splice(idx, 1)
            } else
                if (idx === -1)
                    ///ADD
                    state.questions.splice(0, 0, questionInfo)
                else
                    state.questions.splice(idx, 1, questionInfo)
        },
        SET_Questions(state, payload) {
            state.questions = payload;
        },
        SET_loading(state,payload)
        {
            state.loading=payload;
        }
    },
    actions: {
        async getQuestions({ commit, state }, publicOnly = true) {
            commit('SET_loading',true)
            var result = await window.axios.get('/api/qna/all', { params: { roomid: state.qnaRoom.id, publicOnly: publicOnly } });
            var data = await result.data;
            commit('SET_Questions', data)
            commit('SET_loading',false)
            // window.qnahub.getUnreleasedQuestions();
        }
    },
    modules: {
    }
}
